// components/stats/GlobalStatsTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios    from "axios";
import Table    from "../shared/table/Table";          // mevcut tablo bileşeni
import useTranslations   from "../../hooks/useTranslations";
import useUserLanguage   from "../../hooks/useUserLanguage";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

export default function GlobalStatsTable() {
  /* ───── STATE ───── */
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  /* dil & çeviri */
  const lang             = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d) => translations[k] || d;

  /* ───── FETCH ───── */
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get("/api/global-stats/list", {
          headers:{ Authorization:`Bearer ${token}` },
        });
        setRows(data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  /* ───── COLUMNS ───── */
  const columns = useMemo(() => [
    {
      accessorKey:"institution_count",
      header     :() => t("INSTITUTION_COUNT","Kurum"),
      meta       :{ className:"text-end", headerClassName:"text-end" },
      size       :160,
    },
    {
      accessorKey:"student_count",
      header     :() => t("STUDENT_COUNT","Öğrenci"),
      meta       :{ className:"text-end", headerClassName:"text-end" },
      size       :160,
    },
    {
      accessorKey:"test_count",
      header     :() => t("TEST_COUNT","Çözülen Test"),
      meta       :{ className:"text-end", headerClassName:"text-end" },
      size       :160,
    },
    {
      accessorKey:"updated_at",
      header     :() => t("UPDATED_AT","Son Güncelleme"),
       cell       : info => {
   const v = info.getValue();
   return v
     ? new Date(v).toLocaleDateString("tr-TR")  // SADECE tarih
     : "–";
 },
      meta       :{ className:"text-end", headerClassName:"text-end" },
      size       :220,
    },
  ], [t]);

  /* ───── RENDER ───── */
  if (loading)       return <p>{t("LOADING","Yükleniyor…")}</p>;
  if (!rows.length)  return <p>{t("NO_DATA","Kayıt yok.")}</p>;

  return <Table data={rows} columns={columns} />;
}
